
export class TranslatedKeyPair {
cod: string;
val: string;
}

